/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyByCloudWidgetConfiguration extends models.BaseChartWidgetConfigurationModel {
    constructor() {
        super();
        this.setDiscriminator("CostAnomalyByCloudWidgetConfiguration");
    }

    getFixupPrototypeFunction() { return CostAnomalyByCloudWidgetConfiguration.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyByCloudWidgetConfiguration>): CostAnomalyByCloudWidgetConfiguration {
        let obj = Object.assign(new CostAnomalyByCloudWidgetConfiguration(), model);
        CostAnomalyByCloudWidgetConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyByCloudWidgetConfiguration>): CostAnomalyByCloudWidgetConfiguration {
        if (!model) return null;
        return CostAnomalyByCloudWidgetConfiguration.newInstance(<CostAnomalyByCloudWidgetConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyByCloudWidgetConfiguration) {
        if (!obj) return;

        models.CostAnomalyByCloudWidgetConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyByCloudWidgetConfiguration): boolean {
        if (models.BaseChartWidgetConfigurationModel.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostAnomalyByCloudWidgetConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Granularity to aggregate data
     */
    granularity: models.TrendGranularity;

}
